import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

let router = new Router({
    // base: process.env.BASE_URL,
    // base: '/',

    // mode: 'history',
    routes: [

        {
          path: '/:catchAll(.*)*',
          component: () => import('@/components/AppRetirement')
        },

        // {
        //   path: '/retirement',
        //   component: () => import('@/components/AppRetirement'),
        //   meta: {
        //     requiresAuth: true
        //   }
        // },

        // {
        //     path: '/',
        //     name: 'home',
        //     component: () => import('@/components/account/Login'),
        //     meta: {
        //         requiresAuth: false
        //     }
        // },
        // {
        //     path: '/login',
        //     name: 'login',
        //     component: () => import('@/components/account/Login'),
        //     meta: {
        //         requiresAuth: false
        //     }
        // },
        // {
        //     path: '/reset/:passwordToken',
        //     name: 'reset',
        //     component: () => import('@/components/account/PasswordReset'),
        //     meta: {
        //         requiresAuth: false
        //     },
        //     props: true
        // },
        // {
        //     path: '/stafflogin',
        //     name: 'staffLogin',
        //     component: () => import('@/components/account/StaffLogin'),
        //     meta: {
        //         requiresAuth: false
        //     }
        // },
        // {
        //     path: '/authenticate',
        //     name: 'authenticate',
        //     component: () => import('@/components/account/TwoFactorAuthentication'),
        //     props: true,
        //     meta: {
        //         requiresAuth: false
        //     }
        // },
        // {
        //     path: '/about',
        //     name: 'about',
        //     component: () => import('@/views/About')
        // },
        // {
        //     path: '/profile',
        //     name: 'profile',
        //     component: () => import('@/components/profile/Profile')
        // },
        // {
        //     path: '/bookingavailable_onsite',
        //     name: 'bookingavailable_onsite',
        //     component: () => import('@/components/bookings/BookingAvailable'),
        //     props: {
        //         booking_type: 'onsite',
        //         booking_view: 'booking_available_onsite'
        //     }
        // },
        // {
        //     path: '/bookingavailable_telephone',
        //     name: 'bookingavailable_telephone',
        //     component: () => import('@/components/bookings/BookingAvailable'),
        //     props: {
        //         booking_type: 'telephone',
        //         booking_view: 'booking_available_telephone'
        //     }
        // },
        // {
        //     path: '/bookingavailable_video',
        //     name: 'bookingavailable_video',
        //     component: () => import('@/components/bookings/BookingAvailable'),
        //     props: {
        //         booking_type: 'video',
        //         booking_view: 'booking_available_video'
        //     }
        // },
        // {
        //     path: '/bookingconfirmed',
        //     name: 'BookingConfirmed',
        //     component: () => import('@/components/bookings/BookingConfirmed'),
        //     props: {
        //         booking_view: 'confirmed'
        //     }
        // },
        // {
        //     path: '/bookingconfirmedtoday',
        //     name: 'BookingConfirmedToday',
        //     component: () => import('@/components/bookings/BookingConfirmed'),
        //     props: {
        //         booking_view: 'confirmed_today'
        //     }
        // },
        // {
        //     path: '/searchconfirmed',
        //     name: 'SearchConfirmed',
        //     component: () => import('@/components/bookings/BookingConfirmed'),
        //     props: {
        //         booking_view: 'search_confirmed'
        //     }
        // },
        // {
        //     path: '/searchconfirmedbyday',
        //     name: 'SearchConfirmedByDay',
        //     component: () => import('@/components/bookings/BookingConfirmed'),
        //     props: {
        //         booking_view: 'search_confirmed_by_day'
        //     }
        // },
        // {
        //     path: '/bookingdetail/:ref_num/:parentComp',
        //     name: 'BookingDetail',
        //     component: () => import('@/components/bookings/BookingDetail'),
        //     props: true
        // },
        // {
        //     path: '/booking/:token',
        //     name: 'BookingTokenInfo',
        //     component: () => import('@/components/bookings/BookingTokenInfo'),
        //     props: true
        // },
        // {
        //     path: '/clockon/:token',
        //     name: 'ClockOnActivity',
        //     component: () => import('@/components/activity/ClockActivity'),
        //     props: true
        // },
        // {
        //     path: '/clockoff/:token',
        //     name: 'ClockOffActivity',
        //     component: () => import('@/components/activity/ClockActivity'),
        //     props: true
        // },
        // {
        //     path: '/bookingdecline',
        //     name: 'BookingDecline',
        //     component: () => import('@/components/bookings/BookingDecline'),
        //     props: true
        // },
        // {
        //     path: '/report',
        //     name: 'report',
        //     component: () => import('@/components/report/Report')
        // },
        // // {
        // //     path: '/workingWithChildrenCheck',
        // //     name: 'WorkingWithChildrenCheck',
        // //     component: () => import('@/components/document/WorkingWithChildrenCheck')
        // // },
        // // {
        // //     path: '/policeCheck',
        // //     name: 'PoliceCheck',
        // //     component: () => import('@/components/document/PoliceCheck')
        // // },
        // // {
        // //     path: '/DCSI',
        // //     name: 'clearanceCheck',
        // //     component: () => import('@/components/document/clearanceCheck')
        // // },
        // {
        //     path: '/clearanceCheck/:type/:isEndDate',
        //     name: 'clearanceCheck',
        //     component: () => import('@/components/document/clearanceCheck'),
        //     props: true
        // },
        // {
        //     path: '/transitionLetter',
        //     name: 'transitionLetter',
        //     component: () => import('@/components/document/TransitionLetter')
        // },
        // {
        //     path: '/policyDocuments',
        //     name: 'policyDocuments',
        //     component: () => import('@/components/document/PolicyDocuments')
        // },
        // {
        //     path: '/resources/:type_id',
        //     name: 'resources',
        //     component: () => import('@/components/document/Resources'),
        //     props: true
        // },
        // {
        //     path: '/resourceDetail/:id/:parentComp/:type_id',
        //     name: 'resourceDetail',
        //     component: () => import('@/components/document/ResourceDetail'),
        //     props: true
        // },
        // {
        //     path: '/contactUs',
        //     name: 'contactUs',
        //     component: () => import('@/components/office/ContactUs')
        // },
        // {
        //     path: '/disclaimer',
        //     name: 'disclaimer',
        //     component: () => import('@/components/UnderConstruction')
        // },
        // // {
        // //     path: '/upload/policecheck',
        // //     name: 'disclaimer',
        // //     component: () => import('@/components/UnderConstruction')
        // // },
        // {
        //     path: '/SDPending/:type/:booking_view',
        //     name: 'SDPending',
        //     component: () => import('@/components/serviceDelivery/SDPending'),
        //     props: true
        // },
        // {
        //     path: '/SDUploaded',
        //     name: 'SDUploaded',
        //     component: () => import('@/components/serviceDelivery/SDUploaded'),
        //     props: {
        //         booking_view: 'sd_uploaded'
        //     }
        // }
    ]
});


router.beforeEach((to, from, next) => {
  localStorage.removeItem('jwt');
  localStorage.removeItem('interpreterId');
  localStorage.removeItem('interpreterFirstName');
  localStorage.removeItem('interpreterLastName');
  localStorage.removeItem('interpreterAddress');
  localStorage.removeItem('interpreterSuburb');
  localStorage.removeItem('interpreterPostCode');
  localStorage.removeItem('interpreterPhone');
  localStorage.removeItem('interpreterMobile');
  localStorage.removeItem('interpreterEmail');
  localStorage.removeItem('itProjectId');
  localStorage.removeItem('interpreterLanguages');
  localStorage.removeItem('fmInterpreterId');
  localStorage.removeItem('staffLogin');
  next()
  return;
});

export default router;
